// extracted by mini-css-extract-plugin
export default {"root":"k5dgBC","userContent":"Rw9X3d"};